export default "__VITE_ASSET__DVrT4_Wt__"